import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/markyctian/nes-design/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Input, TextArea, Text, Table } from '@components';
import { Playground } from 'docz';
import { Props } from './config';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const TagVersion = makeShortcode("TagVersion");
const Explain = makeShortcode("Explain");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "input"
    }}>{`Input`}</h2>
    <TagVersion component="Input" mdxType="TagVersion" />
    <h2 {...{
      "id": "use-and-import"
    }}>{`Use and Import`}</h2>
    <Explain component="Input" isCopyable mdxType="Explain" />
    <h2 {...{
      "id": "tips"
    }}>{`Tips`}</h2>
    <Text status="error" mdxType="Text">Input / Textarea share a common component, which needs to be distinguished by inputType</Text>
    <Text status="error" mdxType="Text">输入框和文本框共用一个组件，需要使用 inputType 参数进行区分</Text>
    <h2 {...{
      "id": "case"
    }}>{`Case`}</h2>
    <Playground __position={3} __code={'() => {\n  const [value, setValue] = useState(\'\')\n  return (\n    <>\n      <div style={{ display: \'flex\' }}>\n        Input Value:{\' \'}\n        <Text style={{ marginLeft: 10 }} status=\"success\">\n          {value}\n        </Text>\n      </div>\n      <Input\n        value={value}\n        onChange={e => setValue(e.target.value)}\n        placeholder=\"Input\"\n      />\n      <TextArea\n        value={value}\n        inputType=\"textarea\"\n        placeholder=\"TextArea\"\n        onChange={e => setValue(e.target.value)}\n      />\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Input,
      TextArea,
      Text,
      Table,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Input / TextArea" mdxType="Playground">
  {() => {
        const [value, setValue] = useState('');
        return <>
          <div style={{
            display: 'flex'
          }}>Input Value: <Text style={{
              marginLeft: 10
            }} status="success" mdxType="Text">{value}</Text></div>
          <Input value={value} onChange={e => setValue(e.target.value)} placeholder="Input" mdxType="Input" />
          <TextArea value={value} inputType="textarea" placeholder="TextArea" onChange={e => setValue(e.target.value)} mdxType="TextArea" />
        </>;
      }}
    </Playground>
    <Playground __position={4} __code={'<Input placeholder=\"none\" />\n<Input status=\"success\" placeholder=\"success\" />\n<TextArea\n  inputType=\"textarea\"\n  status=\"warning\"\n  placeholder=\"textarea placeholder\"\n/>\n<Input status=\"error\" placeholder=\"error\" />\n<Input disabled placeholder=\"disabled\" />'} __scope={{
      props,
      DefaultLayout,
      Input,
      TextArea,
      Text,
      Table,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Status" mdxType="Playground">
  <Input placeholder="none" mdxType="Input" />
  <Input status="success" placeholder="success" mdxType="Input" />
  <TextArea inputType="textarea" status="warning" placeholder="textarea placeholder" mdxType="TextArea" />
  <Input status="error" placeholder="error" mdxType="Input" />
  <Input disabled placeholder="disabled" mdxType="Input" />
    </Playground>
    <Playground __position={5} __code={'<Input\n  addonBefore={\n    <div\n      style={{\n        width: 150,\n        display: \'flex\',\n        height: \'100%\',\n        alignItems: \'center\',\n        fontWeight: \'bold\',\n      }}\n    >\n      Before Suffix\n    </div>\n  }\n/>\n<Input\n  inputType=\"textarea\"\n  addonAfter={\n    <div\n      style={{\n        width: 150,\n        display: \'flex\',\n        height: \'100%\',\n        alignItems: \'center\',\n        fontWeight: \'bold\',\n        justifyContent: \'center\',\n      }}\n    >\n      After Suffix\n    </div>\n  }\n/>'} __scope={{
      props,
      DefaultLayout,
      Input,
      TextArea,
      Text,
      Table,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Suffix" mdxType="Playground">
  <Input addonBefore={<div style={{
        width: 150,
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        fontWeight: 'bold'
      }}>
        Before Suffix
      </div>} mdxType="Input" />
  <Input inputType="textarea" addonAfter={<div style={{
        width: 150,
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        fontWeight: 'bold',
        justifyContent: 'center'
      }}>
        After Suffix
      </div>} mdxType="Input" />
    </Playground>
    <Playground __position={6} __code={'<>\n  {[\'text\', \'time\', \'checkbox\', \'password\', \'date\', \'email\'].map(type => (\n    <Input\n      key={type}\n      placeholder={type}\n      type={type}\n      addonBefore={\n        <div\n          style={{\n            width: 100,\n            display: \'flex\',\n            height: \'100%\',\n            alignItems: \'center\',\n            fontWeight: \'bold\',\n          }}\n        >\n          {type}\n        </div>\n      }\n    />\n  ))}\n</>'} __scope={{
      props,
      DefaultLayout,
      Input,
      TextArea,
      Text,
      Table,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="Input Type" mdxType="Playground">
  <>
    {['text', 'time', 'checkbox', 'password', 'date', 'email'].map(type => <Input key={type} placeholder={type} type={type} addonBefore={<div style={{
          width: 100,
          display: 'flex',
          height: '100%',
          alignItems: 'center',
          fontWeight: 'bold'
        }}> 
            {type} 
          </div>} mdxType="Input" />)}
  </>
    </Playground>
    <Playground __position={7} __code={'<TextArea inputType=\"textarea\" theme=\"dark\" />\n<Input theme=\"dark\" status=\"success\" placeholder=\"dark\" />'} __scope={{
      props,
      DefaultLayout,
      Input,
      TextArea,
      Text,
      Table,
      Playground,
      Props,
      DefaultLayout,
      _frontmatter
    }} wrapper="theme" mdxType="Playground">
  <TextArea inputType="textarea" theme="dark" mdxType="TextArea" />
  <Input theme="dark" status="success" placeholder="dark" mdxType="Input" />
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <>
  {[Props.public, Props.input, Props.textarea].map(({
        columns,
        data,
        footer
      }) => <div style={{
        marginTop: 20
      }}>
        <Table theme="dark" columns={columns} data={data} footer={() => <div style={{
          height: 60,
          borderTop: '4px solid white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
              {footer}
            </div>} mdxType="Table" />
      </div>)}
    </>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      